/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_TitleInputs */

const cs_activity_title = /** @type {(inputs: Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivita`)
};

const en_activity_title = /** @type {(inputs: Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Activity_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const activity_title = /** @type {((inputs?: Activity_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activity_title(inputs)
	return cs_activity_title(inputs)
});